import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useState,
} from "react";
import axios from "axios";

const AuthContext = createContext();

export function useAuth() {
  return useContext(AuthContext);
}

export function AuthProvider({ children }) {
  // Auth states - NO token state (token is now in HTTP-only cookie)
  const [user, setUser] = useState(null);
  const [checked, setChecked] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);

  // Login - only store user data, token is in HTTP-only cookie (set by backend)
  const login = useCallback((userData) => {
    setUser(userData);
    setIsAuthenticated(true);
    // Only store non-sensitive user data in localStorage
    localStorage.setItem("admin_export_ethiopia_user", JSON.stringify({ user: userData }));
  }, []);

  // Logout - call backend to clear HTTP-only cookie
  const logout = useCallback(async () => {
    try {
      await axios.get(`${process.env.REACT_APP_BACKEND_URL}adminAuth/logout`, {
        withCredentials: true,
      });
    } catch (error) {
      console.error("Logout request failed:", error);
    }
    setUser(null);
    setIsAuthenticated(false);
    localStorage.removeItem("admin_export_ethiopia_user");
  }, []);

  // Verify session on page load
  useEffect(() => {
    const verifySession = async () => {
      const storedData = localStorage.getItem("admin_export_ethiopia_user");
      if (storedData) {
        try {
          const userData = JSON.parse(storedData);
          if (userData?.user) {
            setUser(userData.user);
            setIsAuthenticated(true);
          }
        } catch (e) {
          localStorage.removeItem("admin_export_ethiopia_user");
        }
      }

      try {
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}adminAuth/me`,
          { withCredentials: true }
        );
        if (response.data?.success && response.data?.data) {
          setUser(response.data.data);
          setIsAuthenticated(true);
          localStorage.setItem("admin_export_ethiopia_user", JSON.stringify({ user: response.data.data }));
        }
      } catch (error) {
        localStorage.removeItem("admin_export_ethiopia_user");
        setUser(null);
        setIsAuthenticated(false);
      }
      setChecked(true);
    };

    verifySession();
  }, []);

  return (
    <AuthContext.Provider value={{ user, checked, isAuthenticated, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}
